<template>
	<Card>
		<template #content>
			<div class="flex flex-col gap-8">
				<FormGroup :label="$t('forms.firmware_type.firmware_type_properties_form.name')" :error-text="form.errors?.name">
					<InputText
					        data-cy="firmware-type-name-input-box"
							ref="name"
							v-model="form.name"
							placeholder="e.g. AB23XYZ"
							@change="form.validate('name')"
					/>
				</FormGroup>

				<FormGroup :label="$t('forms.firmware_type.firmware_type_properties_form.key')" :error-text="form.errors?.key">
					<InputText
					        data-cy="firmware-type-key-input-box"
							v-model="form.key"
							placeholder="e.g. AB23XYZ"
							@change="form.validate('key')"
					/>
				</FormGroup>

				<FormGroup :label="$t('forms.firmware_type.firmware_type_properties_form.company')" :error-text="form.errors?.company_id">
					<Dropdown
					        data-cy="firmware-type-company-selection-input-box"
							v-model="form.company_id"
							:options="companiesStore.getCompanyOptions"
							option-label="name"
							option-value="id"
							:disabled="disabled"
							@change="form.validate('company_id')"
							:placeholder="$t('forms.common.public')"
							show-clear
					/>
				</FormGroup>
			</div>
		</template>

		<template v-if="hasOnSaveListener || hasOnDeleteListener" #footer>
			<div class="flex justify-end space-x-3">
				<Button data-cy="cancel-button-firmware-type" class="px-8" severity="danger" text v-if="hasOnDeleteListener && form.id" @click="$emit('on-delete', form)"
				        :label="$t('forms.common.delete')"
				        :disabled="form.processing"/>
				<Button data-cy="save-button-firmware-type" class="px-8" v-if="hasOnSaveListener" @click="$emit('on-save', form)" :label="$t('forms.common.save')"
				        :disabled="form.processing"/>
			</div>
		</template>
	</Card>
</template>

<script>
import { mapStores } from "pinia";
import { useCompaniesStore } from "@/stores/companies.js";
import FormGroup from "@/Components/FormGroup.vue";

export default {
	name: "FirmwareTypePropertiesForm",
	components: {FormGroup},
	props: {
		form: {
			type: Object,
			required: true,
		},
	},
	computed: {
		...mapStores(useCompaniesStore),
		hasOnSaveListener() {
			return !!(this.$attrs?.onOnSave);
		},
		hasOnDeleteListener() {
			return !!(this.$attrs?.onOnDelete);
		}
	},
	mounted() {
		this.companiesStore.indexCompanyOptions();

		this.$refs.name.$el.focus();
	}
}
</script>

<style scoped>

</style>
